// extracted by mini-css-extract-plugin
module.exports = {"cappedWidth":"_3N5kWfv"};
    if(module.hot) {
      // 1545369452942
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  